var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"loader-wrapper position-absolute"},[(_vm.text)?[_c('span',{staticClass:"loader-wrapper__text"},[_vm._v(_vm._s(_vm.text))])]:[_c('img',{attrs:{"src":"/spinner.gif","alt":"Loading"}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }